/* eslint-disable max-len */
import { useTranslation } from 'react-i18next';
import { ManageCodeLabelColumn } from '../../../../components';

export interface ManageProspectsTableHeadProps {
  columns: ManageCodeLabelColumn[];
};

export const ManageProspectsTableHead = (props: ManageProspectsTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
};
